import * as React from 'react';
import { useMyForm } from '../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    defaultSystemUserGroupResource,
    SystemUserGroupMutationResourceSchema,
    SystemUserGroupPropertyValidation,
    useSystemUserGroupActions,
} from '../../../../resource/resources/persistables/user/systemUserGroupResource';
import { PropertyInputs } from '../../../reusable-components/base/property-bases/PropertyInputs';
import { EditChildBaseDialog } from '../../../reusable-components/dialogs/EditChildBaseDialog';
import {
    Form_DisplayComponentBaseView,
} from '../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { handleMutationResult } from '../../../util/utilFunctions';

export const CreateSystemUserGroupDialog= ({ onClose }: {
    onClose: () => void;
}) => {
    const systemUserGroupActions = useSystemUserGroupActions()
    const addGroup = systemUserGroupActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: SystemUserGroupMutationResourceSchema,
        defaultValues: {
            ...defaultSystemUserGroupResource,
        },
        submitHandler: async (data) => {
            await addGroup.mutateAsync(data, {
                onSuccess: handleMutationResult(() => {
                    onClose();
                }),
            });
        },
    });

    return (
        <EditChildBaseDialog
            edited={form.formState.isDirty}
            onClose={onClose}
            title={'Create System User Group'}
            resourceType={ResourceType.SYSTEM_USER_GROUP}
        >
            <Form_DisplayComponentBaseView form={form} onSubmit={onSubmit} canSubmitDefaultValue={false}>
                <div style={{ paddingTop: 5 }}>
                    <PropertyInputs.Name
                        control={form.control}
                        name={formNames.name}
                        readOnly={false}
                        propertyValidationInformation={{
                            resourceType: ResourceType.SYSTEM_USER_GROUP,
                            propertyIdentifier: SystemUserGroupPropertyValidation.NAME,
                            resourceId: undefined,
                        }}
                    />
                </div>
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};


